module.exports = __webpack_public_path__ + "img/icon-social-youtube-white.c0cf507d.svg";